/* LSC purchase caps — products tagged "limit-N" (e.g. limit-2) are capped at N units.
   Layers: (1) PDP quantity picker max + note, (2) cart-line pickers get the same max,
   (3) cart watcher clamps any line above its cap via /cart/change.js (catches repeated
   add-to-carts, which Shopify merges into one line). Every blocked attempt shows a
   "MAXIMUM AMOUNT REACHED" toast. Tag-driven: no per-product code. */
(function () {
  'use strict';
  var TAG_RE = /^limit-(\d+)$/;
  var MSG_KEY = 'lscLimitMsg';
  var tagCache = {};

  function limitFor(tags) {
    for (var i = 0; i < tags.length; i++) {
      var m = TAG_RE.exec(String(tags[i]).trim());
      if (m) return parseInt(m[1], 10);
    }
    return null;
  }

  function productLimit(handle) {
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        tagCache[handle] = p && p.tags ? limitFor(p.tags) : null;
        return tagCache[handle];
      })
      .catch(function () { tagCache[handle] = null; return null; });
  }

  function noticeText(max) {
    return 'MAXIMUM AMOUNT REACHED — LIMIT ' + max + ' PER CUSTOMER';
  }

  function showNotice(text) {
    var old = document.querySelector('.lsc-limit-toast');
    if (old) old.remove();
    var n = document.createElement('div');
    n.className = 'lsc-limit-toast';
    n.setAttribute('role', 'status');
    n.textContent = text;
    n.style.cssText = 'position:fixed;left:50%;bottom:30px;transform:translateX(-50%);z-index:2147483647;' +
      'background:#000;color:#fff;border:1px solid #fff;padding:14px 22px;' +
      'font-family:"Courier New",Courier,monospace;font-size:12px;letter-spacing:.22em;' +
      'text-transform:uppercase;text-align:center;max-width:92vw;box-shadow:0 6px 28px rgba(0,0,0,.65);';
    document.body.appendChild(n);
    setTimeout(function () { if (n.parentNode) n.remove(); }, 4200);
  }

  function decorateInput(input, max) {
    input.setAttribute('max', String(max));
    if (input.__lscMax) { input.__lscMax = max; return; }
    input.__lscMax = max;
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (v > input.__lscMax) {
        input.value = String(input.__lscMax);
        showNotice(noticeText(input.__lscMax));
      }
    });
  }

  /* plus-button at the cap → feedback (capture phase beats the theme's handler) */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('button[name="plus"]');
    if (!btn) return;
    var wrap = btn.closest('quantity-input') || btn.parentElement;
    var input = wrap && wrap.querySelector('input[name="quantity"], input[name^="updates"]');
    if (input && input.__lscMax && parseInt(input.value, 10) >= input.__lscMax) {
      showNotice(noticeText(input.__lscMax));
    }
  }, true);

  /* ---------- PDP: cap the picker ---------- */
  function capProductPage() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    productLimit(m[1]).then(function (max) {
      if (!max) return;
      /* Studio/Dawn render the qty input OUTSIDE the form (linked via the form attribute) */
      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        decorateInput(input, max);
        var form = input.form || input.closest('form');
        if (form && !form.__lscLimit) {
          form.__lscLimit = true;
          form.addEventListener('submit', function () {
            if (parseInt(input.value, 10) > max) input.value = String(max);
          }, true);
        }
        var qwrap = input.closest('quantity-input') || input.parentElement;
        if (qwrap && qwrap.parentElement && !qwrap.parentElement.querySelector('.lsc-limit-note')) {
          var note = document.createElement('div');
          note.className = 'lsc-limit-note';
          note.textContent = 'LIMIT ' + max + ' PER CUSTOMER';
          note.style.cssText = 'font-family:"Courier New",monospace;font-size:1.1rem;letter-spacing:.2em;opacity:.7;margin-top:.6rem;';
          qwrap.parentElement.appendChild(note);
        }
      });
    });
  }

  /* cap the matching line pickers in the cart page + drawer */
  function decorateCartLines(item, max) {
    document.querySelectorAll('input[name^="updates"]').forEach(function (inp) {
      var vid = inp.getAttribute('data-quantity-variant-id');
      var match;
      if (vid) {
        match = String(vid) === String(item.variant_id);
      } else {
        var row = inp.closest('tr, .cart-item, li, .cart-drawer__item');
        var a = row && row.querySelector('a[href*="/products/"]');
        match = a && a.getAttribute('href').indexOf('/products/' + item.handle) !== -1;
      }
      if (match) decorateInput(inp, max);
    });
  }

  /* ---------- Cart: clamp overages ---------- */
  var enforcing = false;
  function enforceCart() {
    if (enforcing) return;
    enforcing = true;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var work = Promise.resolve(false);
        (cart.items || []).forEach(function (item) {
          work = work.then(function (changed) {
            return productLimit(item.handle).then(function (max) {
              if (!max) return changed;
              decorateCartLines(item, max);
              if (item.quantity > max) {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: max })
                }).then(function () {
                  try { sessionStorage.setItem(MSG_KEY, noticeText(max)); } catch (err) {}
                  showNotice(noticeText(max));
                  return true;
                });
              }
              return changed;
            });
          });
        });
        return work;
      })
      .then(function (changed) {
        enforcing = false;
        if (changed) {
          var guard = 'lscLimitReload';
          if (!sessionStorage.getItem(guard) || Date.now() - Number(sessionStorage.getItem(guard)) > 4000) {
            sessionStorage.setItem(guard, String(Date.now()));
            location.reload();
          }
        }
      })
      .catch(function () { enforcing = false; });
  }

  /* re-check after any cart mutation the theme makes */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(enforceCart, 150); });
    }
    return p;
  };

  document.addEventListener('DOMContentLoaded', function () {
    /* surface the message that triggered a corrective reload */
    try {
      var pending = sessionStorage.getItem(MSG_KEY);
      if (pending) {
        sessionStorage.removeItem(MSG_KEY);
        showNotice(pending);
      }
    } catch (err) {}
    capProductPage();
    enforceCart();
  });
})();
